export default __webpack_public_path__ + "static/heater_w.d667c5839929a527ecad74c1b540152c.png";